//*******************************************************
import { Component }                      from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
// Field Definitions
import  { 
          inviteefield,
          whoseguestinit,
          gifthankyou,
          giftList  
        }                                 from '../../appfirestore/app.fields';
//*******************************************************
@Component(
            {
              selector: 'app-cominviteegiftthankyou',
              templateUrl: './cominviteegiftthankyou.component.html',
              styleUrls: ['./cominviteegiftthankyou.component.scss']
            }
            
          )
//*******************************************************
export class CominviteegiftthankyouComponent 
{
   //*******************************************************
   eventid: string = '';
   formheight: number = 0;

  // Firestore Paths
  pathinvitee: string             = "/eventinvitee/inviteelist";
  pathgiftlist                    = "/eventgiftlist/giftlist";
  pathgiftthankyoulist: string    = "/eventgiftlist/giftthankyou";

  // eventinvitee
  subscriptioninvitee: Subscription;
  subscriptioninviteelist: inviteefield[];

  // giftthankyou
  subscriptiongiftthankyou: Subscription;
  subscriptiongiftthankyoulist: gifthankyou[];

  // gift register
  subscriptiongift: Subscription;
  subscriptiongiftlist: giftList[];

  whoseguest: Array<whoseguestinit> = []; // Empty Array
  invitedeliverylist: string[];
  listinvitationid: string;
  selcurrentdelivery: string;

  giftlist: string[];
  listgiftid: string;

  dragitem: string;
  dragitem_inviteeid: string;

  dragfromcomponent: string;
  dragtocomponent: string;
  dragitemindex: number;
  dragitem_thankyouid: string;
  dragitem_inviteename: string;

  popupVisible:boolean = false;
  popupGiftVisible:boolean = false;
  positionOf: string;

  giftrecieved: string = '';
  deliverylist: string = '';
  //*******************************************************
   constructor ( private firestoredata: firestorecontrol, 
                 private routernavigate: Router,
                 private _Activatedroute:ActivatedRoute
               ) 
     { 

      this.onAdd                    = this.onAdd.bind(this);
      this.onDragStartInviteeName = this.onDragStartInviteeName.bind(this);

      this.onDragStart = this.onDragStart.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);

     }
   //*******************************************************
   ngOnInit(): void 
     {
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
         // Establish Connection to event -> eventparticipant
         this.firestoredata.loadeventinviteenNOthankyoulink( this.eventid );

         this.subscriptioninvitee = this.firestoredata.geteventinviteeNoThankyoulink().subscribe
           ( items => 
             { 
                this.subscriptioninviteelist = items;
                console.log( this.subscriptioninviteelist )
             }
           )
         //---------------------------------------------------------------------------------------------
          // Establish Connection to event -> gifts thankyou register
        this.firestoredata.loadgiftthakyoucard( this.eventid );

        this.subscriptiongiftthankyou = this.firestoredata.geteventtgiftthankyoucardlist().subscribe
          ( items => 
            { 
              this.subscriptiongiftthankyoulist = items;
              //console.log( this.subscriptiongiftthankyoulist )
            }
          )
        //---------------------------------------------------------------------------------------------
         // Establish Connection to event -> eventparticipant
         this.firestoredata.loadeventgiftlist( this.eventid );

         this.subscriptiongift = this.firestoredata.geteventgiftlist().subscribe
           ( items => 
             { 
               this.subscriptiongiftlist = items;
               //console.log( this.subscriptiongiftlist )
             }
           )
       //---------------------------------------------------------------------------------------------
        // Event Organiser Initials
        this.firestoredata.buildwhoseguestdetails( this.eventid );
        this.whoseguest = this.firestoredata.geteventparticipantdetails();
        //---------------------------------------------------------------------------------------------
     }
   //*******************************************************
   ngOnDestroy() 
     {
        console.log('destroy1')
        this.subscriptioninvitee.unsubscribe(); 
        this.subscriptiongiftthankyou.unsubscribe(); 
        this.subscriptiongift.unsubscribe();
     }
  //*******************************************************
  // Dragging Invitee Details frpm DataGrid
  onDragStartInviteeName(e) 
   {
     // DxDatagrid -> DxList
     // Invitee Id
     this.dragitem_inviteeid = e.itemData.id;
     this.dragitem           = e.itemData.firstname + ' ' + e.itemData.lastname + ' - [' +  e.itemData.id + ']' ;

    //  console.log (  this.dragitem_inviteeid  + ' ' + this.dragitem )
   }
//*******************************************************
// Adding Invitee Name to Thankyou Gist List
onAdd(e: any) 
   {
     //console.log( e )
     // Component whhere Item is being Drag from
     this.dragfromcomponent = e.fromComponent.NAME;
     this.dragtocomponent   = e.toComponent.NAME;

  //   console.log(  'From:' + this.dragfromcomponent + ' ' + 'To:' + this.dragtocomponent )
     //---------------------------------------------------------------------------------------------
     // From: dxdatagrid to dxlist
     if ( ( this.dragfromcomponent.toUpperCase()  == 'DXDATAGRID') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
       {
         // Firestore -> tableid
         this.dragitem_thankyouid = this.extract_invitationid( 10, e.toData[0], ':' );

        // console.log( this.dragitem_thankyouid )

         // Add Invitee to Thankyou List
         e.toData.splice(e.toData.length,  0,  this.dragitem );

         // Update Firestore -> Invitee -> tableid
         this.firestoredata.commitbatchupdate( 
                                                 this.pathinvitee, 
                                                 this.eventid,
                                                 this.dragitem_inviteeid,
                                                 'thankyoulinkid', 
                                                 this.dragitem_thankyouid
                                             );

         // Update Firestore -> Table -> giftthankyou
         this.firestoredata.commitbatchupdate( 
                                               this.pathgiftthankyoulist, 
                                               this.eventid,
                                               this.dragitem_thankyouid ,
                                               'inviteename', 
                                               e.toData
                                             );

       }
     //---------------------------------------------------------------------------------------------
     // From: dxlist to dxlist
     if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
       {

         if ( this.dragitemindex != 0 )
           {
             
             this.dragitem_thankyouid = this.extract_invitationid( 10, e.toData[0], ':' );
             this.dragitem_inviteeid  = this.extract_invitationid( 20, this.dragitem, '[' );
         
             // Add Invitee to Destination -> Invitation Thankyou List
             e.toData.splice(e.toData.length,  0,  this.dragitem );

             // Update Firestore -> Invitee -> tableid
             this.firestoredata.commitbatchupdate( 
                                                     this.pathinvitee, 
                                                     this.eventid,
                                                     this.dragitem_inviteeid,
                                                     'thankyoulinkid', 
                                                     this.dragitem_thankyouid
                                                 );

             // Update Firestore -> Table -> list
             this.firestoredata.commitbatchupdate( 
                                                   this.pathgiftthankyoulist, 
                                                   this.eventid,
                                                   this.dragitem_thankyouid,
                                                   'inviteename', 
                                                   e.toData
                                                 );
           }
         
     }
     //---------------------------------------------------------------------------------------------
     // From: dxdatagrid to dxlist
     if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXDATAGRID') )
       {
         //console.log( 'Cannot drop')
         e.cancel = true;
       }
     //---------------------------------------------------------------------------------------------
   }
  //*******************************************************
  onDragStart(e) 
    {

      e.itemData = e.fromData[e.fromIndex];

      this.dragitemindex = e.fromIndex   // Prevent dragitemindex = 0 from being dragged.

      if ( e.fromIndex == 0 )
        {
          e.cancel = true;
        }
      else
        {
          this.dragitem               = e.itemData 
          this.dragitem_inviteename   = this.extract_invitationid( 30, e.itemData, '-' )
        }
    }

  onDragEnd(e) 
    {
      if ( e.toIndex  === 0 )
        {
         // e.cancel = true;
        }
      
    }
  //*******************************************************
  inviteeonItemDeleted( event: any, invitelist: any )
    {
      this.dragitem_thankyouid  = this.extract_invitationid( 10,  invitelist[0], ':' );
      this.dragitem_inviteeid = this.extract_invitationid( 20, event.itemData, '[' );

      this.firestoredata.commitbatchupdate( 
                                              this.pathinvitee, 
                                              this.eventid,
                                              this.dragitem_inviteeid,
                                              'thankyoulinkid', 
                                              '0'
                                          );

      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftthankyoulist, 
                                            this.eventid,
                                            this.dragitem_thankyouid,
                                            'inviteename', 
                                            invitelist   // Array of InviteeName
                                        ).then
                                        ( () => 
                                      
                                          {
                                            if ( invitelist.length == 1 )
                                              {
                                                    this.firestoredata.commitbatchupdate( 
                                                                                          this.pathgiftthankyoulist, 
                                                                                          this.eventid,
                                                                                          this.dragitem_thankyouid,
                                                                                          'deliverylist', 
                                                                                          'TBC'
                                                                                        );

                                              }
                                            else
                                              {

                                                this.firestoredata.thankyoudelivery( this.eventid,this.dragitem_thankyouid ).subscribe
                                                ( (r) => 
                                                  {
                                                                                                                                                     
                                                    this.selcurrentdelivery = r;  
                                                    // Rebuild Pop Up Delivery List
                                                    this.invitedeliverylist = [];
                                                    this.firestoredata.buildinviteedeliveryinvite( this.eventid,'thankyoulinkid', this.dragitem_thankyouid )
                                                      .then( ( inviteedelivery ) => 
                                                                { 

                                                                 // console.log( 'D:' + this.selcurrentdelivery )    

                                                                  this.invitedeliverylist = inviteedelivery

                                                                  if ( this.invitedeliverylist.indexOf( this.selcurrentdelivery ) == -1 )
                                                                    {
                                                                      //console.log( 'Not on List')
                                                                      this.firestoredata.commitbatchupdate( 
                                                                                                            this.pathgiftthankyoulist, 
                                                                                                            this.eventid,
                                                                                                            this.dragitem_thankyouid,
                                                                                                            'deliverylist', 
                                                                                                            'TBC'
                                                                                                          );
                                                                    }
                                                                }
                                                            )
                                                    }
                                                )
                                              }
                                          }
                                        )  


    }
  //*******************************************************
  onClickNewThankyouList( event: any )
  {
    this.firestoredata.crudeventgiftthankyou(  this.eventid )
  }
 //*******************************************************
 extract_invitationid( splittype: number, seltext: string, selsplit: string )
 {

   var retvalue: string;

   switch ( splittype )
     {
       case 10:
           {
             let invitationlistid = seltext.split(selsplit);
 
             retvalue =  invitationlistid[1].trim();
             break
           }

       case 20:
           {
             let invitationlistid = seltext.split(selsplit);

             retvalue = invitationlistid[1].trim();
             retvalue = retvalue.substring(0,4);

             break
           }

       case 30:
           {
             let invitationlistid = seltext.split(selsplit);
 
             retvalue =  invitationlistid[0].trim();
             break
           }
     
     }

   return retvalue;
 }  
//*******************************************************
onDeliveryClicked(e) 
  {
  // console.log( e.id )
  // console.log( e.inviteename )
    this.build_invitee_deliveryoptions(  e.id , e.inviteename )
  }
//*******************************************************
build_invitee_deliveryoptions( thankyoulinkid: string, inviteelist: [])
  {

    this.listinvitationid = thankyoulinkid;

    if ( inviteelist.length > 0 ) 
      {
      
        this.invitedeliverylist = [];
        this.firestoredata.buildinviteedeliveryinvite( this.eventid, 'thankyoulinkid', thankyoulinkid ).then( ( inviteedelivery ) => 
                                                                                                { 
                                                                                                  
                                                                                                  this.positionOf =  `#tileview${thankyoulinkid}`;
                                                                                                  this.invitedeliverylist = inviteedelivery

                                                                                                  this.popupVisible = false;
                                                                                                  if ( this.invitedeliverylist.length > 0 )
                                                                                                    {
                                                                                                      // console.log(this.invitedeliverylist )
                                                                                                      this.popupVisible = true;
                                                                                                    }
                                                                                                  
                                                                                                }
                                                      );
      }

    }
  //*******************************************************
  onItemClick_invitedelivery( event: any, selinviteid: string )  
    {

      // Update Invitation List - Delivery Point
      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftthankyoulist, 
                                            this.eventid,
                                            selinviteid,
                                            'deliverylist', 
                                            event.itemData
                                          );

      this.popupVisible = false;

    }
  //*******************************************************  
  onItemClick_gift( event: any, selthankyouid: string )  
    {
      var giftitem: string;

      giftitem              = event.itemData;
      let giftdetail        = giftitem.split('#');   
      let giftdesc          = giftdetail[0].trim();
      let giftid            = giftdetail[1].trim();
      
      // console.log( giftdesc + ' ' + giftid );

      // Update Gift Details
      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftlist, 
                                            this.eventid,
                                            giftid,
                                            'giftassign', 
                                            true
                                          );
        
      // Update Thankyou-Gift Details
      this.firestoredata.commitbatchupdate( 
                                              this.pathgiftthankyoulist, 
                                              this.eventid,
                                              selthankyouid,
                                              'giftrecieved', 
                                              giftdesc
                                            );

      this.firestoredata.commitbatchupdate( 
                                              this.pathgiftthankyoulist, 
                                              this.eventid,
                                              selthankyouid,
                                              'giftlistlinkid', 
                                              giftid
                                            );

      this.popupGiftVisible = false;

    }
  //******************************************************* 
  onGiftSelectClicked(e) 
  {
    this.build_gift_list( e.id )
  }

  build_gift_list(  selgiftid: string)
    {

      this.giftlist = [];
      this.listgiftid = selgiftid;

      this.firestoredata.buildgiftlist( this.eventid )
        .then( ( giftlist ) => {
                                  this.giftlist = giftlist;

                                  this.positionOf =  `#tileview${selgiftid}`;

                                  this.popupGiftVisible = false;
                                  if ( this.giftlist.length > 0 )
                                    { 
                                      console.log( this.giftlist )
                                      this.popupGiftVisible = true;
                                    }
                               }
              )
    }
//******************************************************* 
  onGiftResetClicked(e) 
    {
     //console.log( e.id, e.giftlistlinkid) 

      // Update Gift Details
      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftlist, 
                                            this.eventid,
                                            e.giftlistlinkid,
                                            'giftassign', 
                                            false
                                          );

      // Update Thankyou-Gift Details
      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftthankyoulist, 
                                            this.eventid,
                                            e.id,
                                            'giftrecieved', 
                                            'TBC'
                                          );

      this.firestoredata.commitbatchupdate( 
                                            this.pathgiftthankyoulist, 
                                            this.eventid,
                                            e.id,
                                            'giftlistlinkid', 
                                            ''
                                          );

    }
  //*******************************************************
  btngiftmouseover( e: any )
   {
      if ( e.giftrecieved == 'TBC')
        {
          this.giftrecieved = 'shshshshshshshs'
        }
      else
        {
          this.giftrecieved = e.giftrecieved;
        }
   }
  //*******************************************************
  btngiftdeliverymouseover( e: any )
  {
     if ( e.deliverylist == 'TBC')
       {
         this.deliverylist = 'xxxxxxxxxxxx'
       }
     else
       {
         this.deliverylist = e.deliverylist;
       }
  }
 //*******************************************************

}
//*******************************************************